/**
 * Shared React Query timing and retry presets for API hooks.
 */

/** Stale time: 30 seconds. */
export const STALE_30S = 30 * 1000;

/** Stale time: 1 minute. */
export const STALE_1M = 1 * 60 * 1000;

/** Stale time: 2 minutes. */
export const STALE_2M = 2 * 60 * 1000;

/** Stale time: 5 minutes. */
export const STALE_5M = 5 * 60 * 1000;

/** Stale time: 10 minutes. */
export const STALE_10M = 10 * 60 * 1000;

/** Retry failed queries once. */
export const RETRY_ONCE = 1;

/**
 * Retry policy that skips 403 and 400 responses (used by reminder API hooks).
 *
 * @param failureCount - Number of failed attempts so far
 * @param error - Error from the failed request
 * @returns Whether React Query should retry
 */
export const noRetryOn403Or400 = (
  failureCount: number,
  error: { response?: { status?: number } }
): boolean => {
  const status = error?.response?.status;
  if (status === 403 || status === 400) return false;
  return failureCount < 1;
};
